import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import type { ComponentProps } from "react";

export type PillProps = ComponentProps<typeof Badge>;

export const Pill = ({ variant = "default", className, ...props }: PillProps) => (
  <Badge variant={variant} className={cn("gap-2 rounded-full px-2.5 py-1 font-normal", className)} {...props} />
);
